import isObject from 'lodash/isObject';
// options are takem from store.rootGetters['getFoldersTranslateOptions']
export const getSystemFolderName = (translationId, options) => {
  if (!options || !isObject(options)) {
    return null;
  }
  const { rootFolders } = options;
  if (!rootFolders) {
    return;
  }

  const folder = rootFolders.find(
    (folder) => folder.translationId === translationId || folder.englishName === translationId
  );
  return folder ? folder.translation : translationId;
};

export const getItemName = (item, options) => {
  const mdata = item.metadata;
  if (mdata && mdata.translation_id && !item.isPreviousDir) {
    return getSystemFolderName(mdata.translation_id, options) || item.name;
  }
  return item.name;
};

export const isSysfolder = (item, options = {}) => {
  if (!options || !isObject(options)) {
    return null;
  }

  const { rootFolders } = options;
  if (!rootFolders) {
    return false;
  }

  const translationId = item.metadata?.translationId;
  return rootFolders.find((folder) => folder.translationId === translationId || folder.englishName === item.name);
};

export const getTranslatedPath = (path, options) => {
  if (!path) {
    return;
  }
  return path
    .split('/')
    .map((pathItem) => getSystemFolderName(pathItem, options) || pathItem)
    .join('/');
};

export const getFilenameTooltip = (item, options = {}, translateCurrentFile = true) => {
  if (!options || !isObject(options)) {
    return null;
  }
  const { currentLanguage } = options;

  if (currentLanguage === 'en_GB' || (!isSysfolder(item, options) && translateCurrentFile)) {
    return null;
  }
  return translateCurrentFile ? getItemName(item, options) : getTranslatedPath(item.path, options);
};

export const getPathTooltip = (item, options) => {
  return getFilenameTooltip(item, options, false);
};
